import { render, staticRenderFns } from "./ShowService.vue?vue&type=template&id=62200fe0"
import script from "./ShowService.vue?vue&type=script&lang=js"
export * from "./ShowService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports